import isMap from './isMap';
export default function get(key, x) {
  return isMap(x) ? x.get(key) : x[key];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/utils/get.js
// module id = 272
// module chunks = 0